import { cn } from '../../../lib/utils'

interface BadgeProps {
  className?: string
  children: React.ReactNode
}
export const Badge = ({ children, className }: BadgeProps): React.ReactElement => {
  return (
    <span
      className={cn(
        'flex justify-center items-center px-2 py-[5px] bg-mist rounded-md text-sm text-primary-gray font-roboto-condensed-medium tracking-wide',
        className,
      )}
    >
      {children}
    </span>
  )
}
